import '../../../../Components/Form/form.css'

import { TextField } from '../../../../Components/Form'
import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { readKey } from '../Functions'
import { genericTravellerFields } from '../Functions'
import { Icon } from '../Icons'
import { SectionShell } from '../SectionShell'
import { getDiffStatus } from './Functions'

const language = cap.language.state || 'IT'
const lang = language.toLowerCase() === 'en' ? 'en' : 'it'
const t = translations[language]

const fieldsById = genericTravellerFields.reduce((acc, f) => ({ ...acc, [f.id]: f }), {})

const DIFF_TO_STATE = { new: 'new', changed: 'changed' }

export const GenericTravellerSection = ({
  state: [state, setState],
  readOnly,
  onClickClear,
  diff
}) => {
  const fields = ['idAccount', 'name', 'lastname', 'email']

  return (
    <SectionShell
      id="traveller"
      icon="user"
      title={t.datiViaggiatore?.toUpperCase() || 'DATI VIAGGIATORE'}
      storageKey="gigiForm.section.traveller-generic"
      contentId="traveller-generic-grid"
    >
      <div className="ff-grid">
        {fields.map((id) => {
          const f = fieldsById[id]
          if (!f) return null
          return (
            <div className="ff-grid__item" key={id}>
              <TextField
                id={`traveller-${id}`}
                label={f.label?.[lang] ?? id}
                value={readKey(state, f.location) ?? ''}
                onChange={() => {}}
                disabled
                diffStatus={DIFF_TO_STATE[getDiffStatus(f, diff)]}
              />
            </div>
          )
        })}
      </div>
      {!readOnly && (
        <button type="button" className="gf-modify-btn" onClick={onClickClear}>
          <Icon name="edit" size={12} />
          {t.modificaViaggiatore}
        </button>
      )}
    </SectionShell>
  )
}
